import { Accordion, Box, Text } from '@mantine/core'
import type { VisitWithRelations } from '@markku/types'
import { TaskAccordionItem } from './TaskAccordionItem'

interface CompletedTasksListProps {
  visit: VisitWithRelations
}

export function CompletedTasksList({ visit }: CompletedTasksListProps) {
  if (!visit.visitTasks?.length) {
    return null
  }

  return (
    <Box>
      <Text size="lg" fw={600} mb="md">
        Hoidetut toimenpiteet
      </Text>

      <Accordion
        chevronPosition="right"
        variant="separated"
        multiple
        styles={{
          control: {
            backgroundColor: 'white',
            borderRadius: 'var(--mantine-radius-md)',
          },
          item: {
            backgroundColor: 'white',
            border: '1px solid var(--mantine-color-gray-3)',
            borderRadius: 'var(--mantine-radius-md)',
            overflow: 'hidden',
          },
        }}
      >
        {visit.visitTasks.map((task, index) => {
          const { attachments = [] } = visit
          const taskAttachments = attachments.filter((a) =>
            task.steps?.some((s) => s.id === a.metadata?.stepId),
          )

          return (
            <TaskAccordionItem
              key={task.id}
              task={task}
              taskAttachments={taskAttachments}
              index={index}
            />
          )
        })}
      </Accordion>
    </Box>
  )
}
